<template>
    <div class="main-container">
        <h2 class="title">Equipo tutoría</h2>
        <Filters 
            @change="(data) => changeFilters(data)"
            :idFilialesReq="userData.id"
        />

        <div class="toggle-view__container">
            <button :class="{'active': !cardsView}" @click.stop="cardsView = false">
                <i class="material-icons">dashboard</i>
                <span>Dashboard</span> 
            </button>
            <button :class="{'active': cardsView}" @click.stop="cardsView = true">
                <i class="material-icons">people</i>
                <span>Tutores</span>
            </button>
        </div>

        <div v-if="completeLoad && !cardsView" class="dashboard">

            <div class="dashboard__row1" v-if="!levelSelected || levelSelected == 5">
                <ExternalChart :title="'Situación laboral'" :idData="{name:'cordinatorId',id:tutorsData.resume.id}" :spName="tutorsData.resume.spName" :graphicDataKey="'workSituation'" :graphicData="tutorsData.resume.workSituation.items" :graphicColors="graphicWorkColors"/>
                <ExternalChart :title="'Situación respecto de Ruky'" :idData="{name:'cordinatorId',id:tutorsData.resume.id}" :spName="tutorsData.resume.spName" :graphicDataKey="'rukySituation'" :graphicData="tutorsData.resume.rukySituation.items" :graphicColors="graphicRukyColors"/>
                <div class="dashboard__jobSearchs">
                    <div v-for="(item,index) in tutorsData.resume.jobSearchData" :key="index" class="dashboard__jobSearchs__item" 
                    @click.stop="navigateParentWindow(tutorsData.resume.spName,tutorsData.resume.id,item.key)">
                        <span>{{$t(`forge_dashboard.${item.key}`)}}</span><span>{{item.value}}</span>
                    </div>
                </div>
            </div>

            <div class="dashboard__row2">
                <ExternalChart :title="'Ingreso a la plataforma'" :idData="{name:'cordinatorId',id:tutorsData.resume.id}" :spName="tutorsData.resume.spName" :graphicDataKey="'loginStatus'" :graphicData="tutorsData.resume.loginStatus.items" :graphicColors="graphicLoginColors"/>
                <ExternalChart v-if="!levelSelected || levelSelected == 5" :title="'Actividades para postular'" :idData="{name:'cordinatorId',id:tutorsData.resume.id}" :spName="tutorsData.resume.spName" :graphicDataKey="'tripStatus'" :graphicData="tutorsData.resume.tripStatus.items" :graphicColors="graphicTripColors"/>
                <ExternalChart :title="'Completitud de perfiles'" :idData="{name:'cordinatorId',id:tutorsData.resume.id}" :spName="tutorsData.resume.spName" :graphicDataKey="'profileCompletition'" :graphicData="tutorsData.resume.profileCompletition.items" :graphicColors="graphicProfileColors"/>
            </div>

        </div>

        <div v-if="completeLoad && cardsView" class="cards-tutors">
            <div v-if="levelSelected && levelSelected < 5" class="empty-state">
                <i class="material-icons">error</i>
                <span>Solo disponible para nivel 5</span>
            </div>
            <div v-else-if="!tutorsData.tutors.length">
                No hay tutores para mostrar
            </div>
            <template v-else>
                <article  v-for="(tutor,index) in tutorsData.tutors" :key="index" class="tutor-card">

                    <div class="tutor-card__header">
                        <!-- <img src="https://via.placeholder.com/80" alt=""> -->
                        <div>
                            <router-link :to="`/tutor-detail-dashboard/${tutor.id}`">
                                <h3>{{tutor.firstname}} {{tutor.lastname}} <i class="material-icons">launch</i></h3>
                            </router-link>
                        </div>
                    </div>

                    <div>
                        <div v-for="(item,index) in tutor.students.items" :key="index" class="tutor-card__item tutor-card__item-students">
                            <span class="name">{{$t(`forge_dashboard.${item.name}`)}}</span>
                            <span v-if="item.name != 'All'" class="value">{{item.value}} ({{item.percentage}}%)</span>
                            <span v-else class="value">{{item.value}}</span>
                        </div>
                    </div>
                    <div>
                        <div v-for="(item,index) in tutor.rukySituation.items" :key="index" class="tutor-card__item"
                        :class="{'--bad': item.name == 'NO_POSTULABLE_NO_INVITADO_RUKY','--good': item.name == 'INVITADO_RUKY'}">
                            <span class="name">{{$t(`forge_dashboard.${item.name}`)}}</span>
                            <span class="value">{{item.value}} ({{item.percentage}}%)</span>
                        </div>
                    </div>
                    <div>
                        <div v-for="(item,index) in tutor.workSituation.items" :key="index" class="tutor-card__item" 
                        :class="{'--bad': item.name == 'NO_WORK','--good': item.name == 'FORMAL' || item.name == 'OWN_WORK','--regular': item.name == 'INFORMAL'}">
                            <span class="name">{{$t(`forge_dashboard.${item.name}`)}}</span>
                            <span class="value">{{item.value}} ({{item.percentage}}%)</span>
                        </div>
                    </div>
                    <div>
                        <div v-for="(item,index) in tutor.tripStatus.items" :key="index" class="tutor-card__item"
                        :class="{'--bad': item.name == 'TRIP_PENDING','--good': item.name == 'TRIP_COMPLETED'}">
                            <span class="name">{{$t(`forge_dashboard.${item.name}`)}}</span>
                            <span class="value">{{item.value}} ({{item.percentage}}%)</span>
                        </div>
                    </div>
                    <div>
                        <span class="profile-completition-title">Completitud de perfil Ruky</span>
                        <div v-for="(item,index) in tutor.profileCompletition.items" :key="index" class="tutor-card__item"
                        :class="{'--bad': item.name == 'LESS_30','--good': item.name == 'BETWEEN_80AND99' || item.name == 'COMPLETED', '--regular': item.name == 'BETWEEN_30AND49' || item.name == 'BETWEEN_50AND79'}">
                            <span class="name">{{$t(`forge_dashboard.${item.name}`)}}</span>
                            <span class="value">{{item.value}} ({{item.percentage}}%)</span>
                        </div>
                    </div>
                </article>
            </template>
        </div>
    </div>
</template>

<script>
import { useStore } from 'vuex';
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import moment from 'moment';
import ExternalChart from '@/components/External/Chart.vue';
import Filters from './Filters.vue';

export default {
    components:{
        ExternalChart,
        Filters
    },
    setup() {
        const store = useStore();
        const { t } = useI18n();
        const tutorsData = ref();
        const completeLoad = ref();
        const userData = computed(() => store.getters.externalData_userData);
        //const viewData = computed(() => store.getters.externalData_viewData);
        const cardsView = ref(false);
        
        const graphicWorkColors = {
            NO_WORK: 'red',
            OWN_WORK: 'lightred',
            FORMAL: 'green',
            INFORMAL: 'yellow'
        }
        const graphicRukyColors = {
            NO_POSTULABLE_NO_INVITADO_RUKY: 'red',
            INVITADO_RUKY: 'green',
        }
        const graphicLoginColors = {
            NO_AFTER30: 'green', //Ingresaron hace menos de 30 dias
            NO_BEFORE30: 'yellow',
            NO_LOGIN: 'red'
        }
        const graphicTripColors = {
            TRIP_COMPLETED: 'green',
            TRIP_PENDING: 'red'
        }
        const graphicProfileColors = {
            COMPLETED: 'green',
            LESS_30: 'red',
            BETWEEN_30AND49: 'yellow',
            BETWEEN_50AND79: 'lightred',
            BETWEEN_80AND99: 'lightgreen'
        }

        function formatDate(dateTime) {
            return moment(dateTime).isValid() ? moment(dateTime).format("DD/MM/YYYY") : "";
        }

        function navigateParentWindow(spName,id,value){
            let sp = {
                spName : spName,
                spData : { 
                    cordinatorId: id,
                    detailKey: 'jobSearchData',
                    detailValue: value
                }
            } 
            parent.postMessage(JSON.stringify({
                type:"FullNavigate",
                data: {
                    module:"Referenciales",
                    view:"ShowDataView",
                    params: {
                        params : [
                            {
                                dataType:"ExternalDashboardData",
                                originalData: JSON.stringify(sp)
                            }
                        ]
                    },
                    tabName: t(`forge_dashboard.${value}`)
                }
            }),"*");
        }

        const levelSelected = ref(null)
        async function changeFilters(data){
            levelSelected.value = data.level;
            await getData(data)
            completeLoad.value = true;
        }

        async function getData(filters=null){
            completeLoad.value = false;
            try {
                tutorsData.value = await store.dispatch('forgeDash_cordinatorResume',{ id: userData.value.id, queryParams: filters?.queryParams || '' });
                if(!filters) completeLoad.value = true;
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create', { text: t(`notifications.generic`) });
            }
        }

        onMounted(()=>{
            getData();
        });

        return{
            tutorsData,
            completeLoad,
            formatDate,
            cardsView,
            graphicWorkColors,
            graphicRukyColors,
            graphicLoginColors,
            graphicTripColors,
            graphicProfileColors,
            navigateParentWindow,
            changeFilters,
            levelSelected,
            userData
        }
    },
}
</script>

<style lang="scss" scoped>

* {
    box-sizing: border-box;
}

.main-container {
    box-sizing: border-box;
    width: calc(100% - 32px);
    margin: $margin-base;
    padding: $margin-mega;
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    gap: $margin-base;
    background: #FFFFFF;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);
    border-radius: $margin-base;
}

.title {
    font-style: normal;
    font-weight: 600;
    font-size: 26px;
    color: #231F20;
    margin: 0;
}

.toggle-view__container{
    display: flex;
    flex-flow: row nowrap;
    gap: 16px;
    button{
        padding: 12px;
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-items: center;
        gap: 8px;
        border-radius: 8px;
        background-color: #DBDBDB;
        color: #231F20;
        span{
            font-style: normal;
            font-weight: 600;
            font-size: 18px;
            line-height: 16px;
        }
    }
    .active{
        background-color: $orange !important;
        >* {
            color: #fff !important;
        }
    }
}

.dashboard{
    width: 100%;
    display: flex;
    flex-flow: column nowrap;
    gap: 24px;
    &__row1, &__row2{
        display: flex;
        flex-flow: row nowrap;
        gap: 24px;
    }
    &__jobSearchs{
        width: 33.3%;
        height: fit-content;
        padding: 16px;
        display: flex;
        flex-flow: column nowrap;
        gap: 16px;
        border: 1px solid #C4C4C4;
        border-radius: 4px;
        &__item{
            height: fit-content;
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: center;
            gap: 52px;
            cursor: pointer;
            span{
                font-weight: 600;
            }
        }
    }
}

.cards-tutors{
    display: flex;
    flex-flow: row wrap;
    gap: 24px;
    .tutor-card{
        width: 350px;
        padding: 16px;
        display: flex;
        flex-flow: column nowrap;
        box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
        border-radius: 8px;
        h3{
            margin: 0;
            display: flex;
            align-items: center;
            gap: 4px;
        }
        >div{
            padding: 12px 0;
            border-bottom: 1px solid #C4C4C4;
            display: flex;
            flex-flow: column nowrap;
            gap: 4px;
            &.tutor-card__header{
                padding-top: 0;
            }
        }
        >div:last-child{
            border: none;
            padding-bottom: 0;
        }
        .profile-completition-title{
            padding: 0 0 8px 4px;
            font-size: 16px;
            font-weight: 600;
        }
        &__item{
            padding: 12px;
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: center;
            border-radius: 6px;
            &-students{
                padding: 4px;
            }
            span{
                max-width: 60%;
                font-weight: 600;
                font-size: 14px;
            }
        }
        .--good{
            background-color: #DCEFDE;
        }
        .--bad{
            background-color: #FFE8E8;
        }
        .--regular{
            background-color: #FFF9E2;
        }
    }
}

</style>
<style>
.custom-container {
    background:#fff;
}
</style>